import React from 'react';
import { Report } from 'cccisd-laravel-report';
import FlexibilityReport from '../Report';

const Component = props => {
    return (
        <div style={{ width: '840px', margin: '0 auto', maxWidth: '100%' }}>
            <Report downloadFilename="FlexibilityReport" height="600px">
                <FlexibilityReport {...props} />
            </Report>
        </div>
    );
};

export default Component;
